<script>
  export let field;
</script>

{#if field.error}
  <p class="calculator-error py-6">{field.errorMessage}</p>
{:else}
  <p class="text-15 py-6">&nbsp;</p>
{/if}



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/CalculatorFieldError.svelte